import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnershipInstitutionsGlobalRegionViewModel } from './peer-ownership-institutions-breakdown.model';

export class PeerOwnershipInstitutionsGlobalRegionConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipInstitutionsGlobalRegionConfiguration';
  nodataLocalizationKeyName = 'peerOwnershipInstitutionsGlobalRegion';
  readonly reportSection = ReportSection.PeerOwnershipInstitutionsGlobalRegion;
  readonly name = 'peerOwnershipInstitutionsGlobalRegion';
  readonly displayName = 'Global Region - Institutions';
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_InstitutionsGlobalRegion];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'peerOwnershipInstitutionsGlobalRegionGraph',
      displayName: 'Graph',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'peerOwnershipInstitutionsGlobalRegionGeoOpportunitiesTable',
      displayName: 'Geo Opportunities by Purchasing Power Table',
      isSelected: true,
      canConfigure: true,
      type: ReportSectionConfigurationControlType.Table
    }
  ];
}

export interface PeerOwnershipInstitutionsGlobalRegionDataBag {
  [ReportViewModelSection.PeerOwnershipReport_InstitutionsGlobalRegion]: PeerOwnershipInstitutionsGlobalRegionViewModel;
}
